import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setAuth } from "../redux/auth/actions";

const { REACT_APP_URL_HXROAPI } = process.env;

export default function useBalance() {
  const auth = useSelector((state: any) => state?.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!auth?.token) {
      return;
    }

    const getBalance = () => {
      axios
        .get(`${REACT_APP_URL_HXROAPI}/profile`)
        .then(({ data }) => {
          auth.balance = data?.balance || 0;
          dispatch(setAuth({ ...auth }));
        })
        .catch(() => {
          getBalance();
        });
    };

    getBalance();
  }, [auth?.token]);

  return auth?.balance;
}
